import React, { Component } from 'react';
import LandlordLogo from 'components/shared/LandlordLogo';

class NavBar extends Component {
  render() {
    return (
      <div className="nav-bar" style={{ position: 'fixed', width: '100%' }}>
        <header className="global-header-view">
          <nav>
            <div className="navigation-canvas">
              <div>
                <div className="global-header-left">
                  <div
                    style={{
                      width: '89px',
                      borderRight: '1px solid #f7f7f7',
                      display: 'inline-flex',
                      height: '60px',
                    }}
                  >
                    <div className="global-header-item-container">
                      <span className="global-header-left global-header-item">
                        <div
                          className="row"
                          style={{
                            width: '116px',
                            float: 'left',
                            marginTop: '-1px',
                            marginLeft: '8px',
                          }}
                        >
                          <LandlordLogo maxWidth="116px" height="46px" textHeight="27px" />
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </header>
      </div>
    );
  }
}

export default NavBar;
